import request from "../request";

/**
 * Очистка корзины
 * @return {Promise}
 */
export const cancelAll = () => {
	return request({
		url: "/order/cancel-all",
	});
};

export const cancel = ({orderId}) => {
	return request({
		url: `/order/cancel?id=${orderId}`,
	});
};

export const getAcquirings = ({orderId, needOverlay}) => {
	return request({
		url: `/order/get-acquirings/${orderId}`,
		type: "GET",
		needOverlay,
	});
};
